/**
 * Production-safe logger utility
 * Prevents sensitive data logging in production
 */

const isDevelopment = import.meta.env.DEV;

export const logger = {
  /**
   * Log general information (development only)
   */
  info: (...args: unknown[]) => {
    if (isDevelopment) {
      console.log('[INFO]', ...args);
    }
  },

  /**
   * Log errors (sanitized in production)
   */
  error: (message: string, error?: unknown) => {
    if (isDevelopment) {
      console.error('[ERROR]', message, error);
    } else {
      // In production, only log generic error message without exposing details
      console.error('[ERROR]', message);
    }
  },

  /**
   * Log warnings (development only)
   */
  warn: (...args: unknown[]) => {
    if (isDevelopment) {
      console.warn('[WARN]', ...args);
    }
  },

  /**
   * Debug logging (development only)
   */
  debug: (...args: unknown[]) => {
    if (isDevelopment) {
      console.debug('[DEBUG]', ...args);
    }
  }
};
